// extracted by mini-css-extract-plugin
export default {"container":"Category_container__IAz6e","eventCard":"Category_eventCard__tcowm","eventCardTitle":"Category_eventCardTitle__UIdqL"};